import { TEST_IDS } from "./TestIds";
import { TRANSLATION_KEYS } from "./TranslationKeys";

import type { ToastProps } from "components/toasts/MessageToast";

export const USER_TOASTS_IDS = {
  createFailure: TEST_IDS.userCreateFailureToast,
  createSuccess: TEST_IDS.userCreateSuccessToast,
  editFailure: TEST_IDS.userEditFailureToast,
  editSuccess: TEST_IDS.userEditSuccessToast,
} as const;

export const USER_TOASTS = {
  createUserSuccess: (message: string): ToastProps => ({
    bodyContent: message,
    variant: "success",
    config: {
      toastId: USER_TOASTS_IDS.createSuccess,
      updateId: "user-create-success-update-id",
    },
  }),
  createUserFailure: (message: string): ToastProps => ({
    bodyContent: message,
    variant: "failure",
    config: {
      toastId: USER_TOASTS_IDS.createFailure,
      updateId: "user-create-failure-update-id",
    },
  }),
  editUserSuccess: (
    message: string = TRANSLATION_KEYS.theUserHasBeenModified
  ): ToastProps => ({
    bodyContent: message,
    variant: "success",
    config: {
      toastId: USER_TOASTS_IDS.editSuccess,
      updateId: "user-edit-success-update-id",
    },
  }),
  editUserFailure: (message: string): ToastProps => ({
    bodyContent: message,
    variant: "failure",
    config: {
      toastId: USER_TOASTS_IDS.editFailure,
      updateId: "user-edit-failure-update-id",
    },
  }),
} as const;
